import { groq } from '#imports';

export function getQuery({ offset = 0, limit = 10 } = {}) {
  return groq`*[_type == "article" && !(_id in path('drafts.**'))] | order(publishedAt desc) [${offset}...${limit}] {
    slug,
    image,
    title,
    subtitle,
    publishedAt,
    isArticleExternalSourceType,
    externalSource,
    crew[]{staff->, speciality->},
  }`;
}
